/* Inline product-card "Quick selection" size overlay.
   - Clicking a size adds that variant via the theme's `theme:cart:add` event.
   - Hovering a colour swatch "selects" that colour: swaps the quick-add sizes,
     the card title, image, product links, and the selection ring to that colour.
     Leaving the card resets everything back to the card's own colour. */
(function () {
  if (window.__cardQuickSizesBound) return;
  window.__cardQuickSizesBound = true;

  function sizeLabel(t) {
    t = String(t);
    return t.indexOf(' / ') > -1 ? t.split(' / ').pop() : t;
  }

  function buildRow(variants) {
    var html = '';
    for (var j = 0; j < variants.length; j++) {
      var v = variants[j];
      html +=
        '<button type="button" class="card-quick-sizes__btn" data-cqs-add data-variant-id="' +
        v.id + '"' + (v.a ? '' : ' disabled aria-disabled="true"') + '>' +
        sizeLabel(v.t) + '</button>';
    }
    return html;
  }

  function firstAvailableId(variants) {
    for (var i = 0; i < variants.length; i++) if (variants[i].a) return variants[i].id;
    return variants.length ? variants[0].id : '';
  }

  function links(card) {
    return card.querySelectorAll('a.product-link, [data-product-link]');
  }

  function showSiblingImage(card, sw) {
    var sibWrap = card.querySelector('.product-item__bg__sibling');
    var imgUrl = sw.getAttribute('data-sibling-image');
    if (!sibWrap || !imgUrl) return;
    sibWrap.style.backgroundImage = 'url("' + imgUrl + '")';
    sibWrap.style.backgroundSize = 'cover';
    sibWrap.style.backgroundPosition = 'center';
    sibWrap.style.zIndex = '3';
    var innerImg = sibWrap.querySelector('img');
    if (innerImg && innerImg.getAttribute('src') !== imgUrl) {
      innerImg.setAttribute('src', imgUrl);
      innerImg.removeAttribute('srcset');
      innerImg.removeAttribute('data-srcset');
    }
    sibWrap.classList.add('is-visible');
  }

  function hideSiblingImage(card) {
    var sibWrap = card.querySelector('.product-item__bg__sibling');
    if (!sibWrap) return;
    sibWrap.classList.remove('is-visible');
    sibWrap.style.backgroundImage = '';
    sibWrap.style.backgroundSize = '';
    sibWrap.style.backgroundPosition = '';
    sibWrap.style.zIndex = '';
  }

  function storeDefaults(card, overlay, titleEl) {
    if (card.__cqsDefaults) return;
    var row = overlay ? overlay.querySelector('.card-quick-sizes__row') : null;
    var idInput = overlay ? overlay.querySelector('[data-cqs-id]') : null;
    var firstLink = card.querySelector('a.product-link, [data-product-link]');
    var colorNameEl = card.querySelector('.product-item__color-name');
    card.__cqsDefaults = {
      title: titleEl ? titleEl.textContent : null,
      colorName: colorNameEl ? colorNameEl.textContent : null,
      rowHTML: row ? row.innerHTML : null,
      id: idInput ? idInput.value : null,
      link: firstLink ? firstLink.getAttribute('href') : null
    };
  }

  function applyColour(card, overlay, titleEl, variants, sw) {
    /* quick-add sizes */
    if (overlay) {
      var row = overlay.querySelector('.card-quick-sizes__row');
      var idInput = overlay.querySelector('[data-cqs-id]');
      if (row && variants) row.innerHTML = buildRow(variants);
      if (idInput) idInput.value = firstAvailableId(variants);
    }
    /* colour name only — keep the product title stable so hovering can't reflow
       the card (a wrapping title used to shift the swatches and break the hover) */
    var colorNameEl = card.querySelector('.product-item__color-name');
    var colorName = sw.getAttribute('data-color-name');
    if (colorNameEl && colorName) colorNameEl.textContent = colorName;
    /* image (show the sibling-image overlay with this colour's photo) */
    showSiblingImage(card, sw);
    /* product links / url */
    var url = sw.getAttribute('data-sibling-link');
    if (url) {
      var ls = links(card);
      for (var i = 0; i < ls.length; i++) ls[i].setAttribute('href', url);
    }
  }

  function resetCard(card) {
    var d = card.__cqsDefaults;
    if (!d) return;
    var overlay = card.querySelector('.card-quick-sizes');
    var titleEl = card.querySelector('.product-item__title');

    if (overlay) {
      var row = overlay.querySelector('.card-quick-sizes__row');
      var idInput = overlay.querySelector('[data-cqs-id]');
      if (row && d.rowHTML != null) row.innerHTML = d.rowHTML;
      if (idInput && d.id != null) idInput.value = d.id;
    }
    if (titleEl && d.title != null) titleEl.textContent = d.title;
    var colorNameEl = card.querySelector('.product-item__color-name');
    if (colorNameEl && d.colorName != null) colorNameEl.textContent = d.colorName;

    hideSiblingImage(card);

    if (d.link != null) {
      var ls = links(card);
      for (var i = 0; i < ls.length; i++) ls[i].setAttribute('href', d.link);
    }

    var swatches = card.querySelectorAll('[data-sibling-variants]');
    for (var k = 0; k < swatches.length; k++) swatches[k].classList.remove('is-cqs-active');
    card.classList.remove('cqs-has-active');
    card.__cqsActiveSwatch = null;
  }

  /* Click a size -> add to cart via the theme */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cqs-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

    var form = btn.closest('form');
    if (!form) return;
    var idInput = form.querySelector('[data-cqs-id]');
    if (idInput) idInput.value = btn.getAttribute('data-variant-id');

    btn.classList.add('is-loading');
    document.dispatchEvent(
      new CustomEvent('theme:cart:add', { detail: { button: btn }, bubbles: false })
    );
    setTimeout(function () { btn.classList.remove('is-loading'); }, 1200);
  });

  /* Re-assert the active colour's image/title/links (the theme's own sibling
     swap reverts these when the mouse leaves the swatch, even while still in the
     card). Lightweight: only touches things that drifted, no overlay rebuild. */
  function reassert(card, sw) {
    var colorNameEl = card.querySelector('.product-item__color-name');
    var colorName = sw.getAttribute('data-color-name');
    if (colorNameEl && colorName && colorNameEl.textContent !== colorName) colorNameEl.textContent = colorName;

    showSiblingImage(card, sw);

    var url = sw.getAttribute('data-sibling-link');
    if (url) {
      var ls = links(card);
      for (var i = 0; i < ls.length; i++) if (ls[i].getAttribute('href') !== url) ls[i].setAttribute('href', url);
    }
  }

  /* Hover a colour swatch -> select it. Moving elsewhere in the card -> keep it. */
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest('[data-sibling-variants]');

    if (sw) {
      var card = sw.closest('.product-item');
      if (!card) return;
      if (card.__cqsActiveSwatch === sw) { reassert(card, sw); return; }

      var overlay = card.querySelector('.card-quick-sizes');
      var titleEl = card.querySelector('.product-item__title');
      var variants;
      try { variants = JSON.parse(sw.getAttribute('data-sibling-variants')); } catch (err) { return; }
      if (!variants || !variants.length) return;

      storeDefaults(card, overlay, titleEl);
      card.__cqsActiveSwatch = sw;
      applyColour(card, overlay, titleEl, variants, sw);

      var swatches = card.querySelectorAll('[data-sibling-variants]');
      for (var i = 0; i < swatches.length; i++) swatches[i].classList.remove('is-cqs-active');
      sw.classList.add('is-cqs-active');
      card.classList.add('cqs-has-active');
      return;
    }

    /* Not on a swatch: if this card has a selected colour, keep it applied. */
    var inCard = e.target.closest('.product-item');
    if (inCard && inCard.__cqsActiveSwatch) reassert(inCard, inCard.__cqsActiveSwatch);
  });

  /* Leave the card entirely -> reset. Deferred + :hover check so moving between
     the swatches and the overlay (which can fire mouseout with a null
     relatedTarget) does NOT reset. */
  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest('.product-item');
    if (!card || !card.__cqsDefaults) return;
    setTimeout(function () {
      if (card.matches(':hover')) return;
      resetCard(card);
    }, 60);
  });
})();
